import { clsx } from 'clsx'
import { type FC } from 'react'

import {
  type OfferPriceV1,
  PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../../global-config'
import { priceGetFormattedPercentageDiscount } from '../../../../price'
import { ProductDiscount } from '../../../../product'
import { bonusEnabledPrescriptionTypes } from '../models/bonusEnabledPrescriptionTypes'

import { PrescriptionBadgeContent } from './PrescriptionBadgeContent'

type ProductDiscountBadgeProps = {
  className?: string
  currentPrescriptionType: PrescriptionPrescriptionTypeEnum
  'data-qa-id'?: string
  discount: number
  isDiscountValid: boolean
  offerPrice: OfferPriceV1 | null
  showInfo?: boolean
  showThirtyDaysPrice: boolean
}

export const ProductDiscountBadge: FC<ProductDiscountBadgeProps> = ({
  className,
  currentPrescriptionType,
  'data-qa-id': dataQaId,
  discount,
  isDiscountValid,
  offerPrice,
  showInfo,
  showThirtyDaysPrice,
}) => {
  const { superScripts } = useGlobalConfigContext()

  if (
    currentPrescriptionType === PrescriptionPrescriptionTypeEnum.NoPrescription
  ) {
    if (!discount || !isDiscountValid) {
      return null
    }

    return (
      <ProductDiscount
        className={clsx(
          'rounded-full bg-light-tertiary font-mono text-xs font-medium',
          className,
        )}
        data-qa-id={dataQaId}
        discount={priceGetFormattedPercentageDiscount(discount)}
        supNote={
          showThirtyDaysPrice
            ? superScripts.discountThirtyDays
            : superScripts.supNoteNumber
        }
      />
    )
  }

  if (bonusEnabledPrescriptionTypes.includes(currentPrescriptionType)) {
    if (!offerPrice?.bonus) {
      return null
    }

    return (
      <PrescriptionBadgeContent
        bonus={offerPrice.bonus}
        className={className}
        data-qa-id={dataQaId}
        showInfo={showInfo}
      />
    )
  }

  return null
}
